"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('home', {
            url: '/home',
            template: require('../views/dashboard.html'),
            controller: 'DashboardController',
            controllerAs: 'dashboard'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/config/routes.js
// module id = 348
// module chunks = 0